import React, { useEffect, useState } from "react";
import { MdAdd } from "react-icons/md";
import { FiMinus } from "react-icons/fi";
import { toast } from "react-toastify";
import Modal from "./Modal";

const TransactionTable = ({
  reconTxns,
  setShowOurList,
  setAddedDataForRecon,
}) => {
  const [reconArr, setReconArr] = useState([]);
  const [modalData, setModalData] = useState(null);
  const [openModal, setOpenModal] = useState(false);

  const toggleTxn = () => {
    const validTxns = reconTxns.filter(
      (item) =>
        item?.responseData?.RESPONSE_STATUS?.toLowerCase() === "success"
    );
    if (reconArr.length === validTxns.length) {
      setReconArr([]);
      toast.success("All transactions removed from Chargeback.");
    } else {
      if (validTxns.length === 0) {
        toast.error(
          "You are trying to add invalid status transactions to chargeback."
        );
        return;
      }

      setReconArr(validTxns);
      toast.success("All valid transactions added for Chargeback.");
    }
  };

  
  const handleAddTxn = (item) => {
    const status = item?.responseData?.RESPONSE_STATUS?.toLowerCase();
    if (status === "processing" || status === "failed") {
      toast.error(
        "Invalid status. Only SUCCESS transactions can be added to chargeback."
      );
      return;
    }
    setReconArr((prevState) => [...prevState, item]);
    toast.success("Transaction added for Chargeback.");
  };

  const handleRemoveTxn = (item) => {
    setReconArr((prevState) =>
      prevState.filter((prevItem) => prevItem.id !== item.id)
    );
    toast.success("Transaction removed from Chargeback.");
  };

  const handleSubmitReconTxns = () => {
    if (reconArr.length === 0) {
      toast.warning("Select atleast one transaction for Chargeback");
      return;
    }

    setAddedDataForRecon(reconArr);
    setShowOurList(true);
  };

  const viewData = (item) => {
    setModalData(item);
    setOpenModal(true);
  };

  const statusStyle = (status) => ({
    fontWeight: 500,
    padding: "4px 8px",
    borderRadius: "6px",
    display: "inline-block",
    color:
      status === "SUCCESS"
        ? "#16a34a"
        : status === "PROCESSING"
        ? "#2563eb"
        : "#dc2626",
    backgroundColor:
      status === "SUCCESS"
        ? "#dcfce7"
        : status === "PROCESSING"
        ? "#dbeafe"
        : "#fee2e2",
  });

  return (
    <div>
      <div className="table-recon-report">
        <table className="table-recon-transaction">
          <thead className="table-recon-head">
            <tr>
              <td>
                <p className="recon-table-head-report">Order Id</p>
              </td>
              <td>
                <p className="recon-table-head-report">Amount(₹)</p>
              </td>
              <td>
                <p className="recon-table-head-report">Status</p>
              </td>
              <td>
                <p className="recon-table-head-report">Date</p>
              </td>
              <td>
                <p className="recon-table-head-report">View</p>
              </td>
              <td>
                <p className="recon-table-head-report">
                  Actions{" "}
                  {reconArr.length === reconTxns.length ? (
                    <FiMinus size={22} onClick={toggleTxn} />
                  ) : (
                    <MdAdd size={22} onClick={toggleTxn} />
                  )}
                </p>
              </td>
            </tr>
          </thead>

          <tbody>
            {reconTxns.map((item, index) => {
              const dataItem = JSON.parse(item.request);
              const responseData = JSON.parse(item.resposne);
              item.dataItem = dataItem;
              item.responseData = responseData;
              const date = new Date(item.createdAt);
              const formattedDate = date.toLocaleDateString();
              const formattedTime = date.toLocaleTimeString();

              return (
                <tr key={index} className="recon-table-head-report">
                  <td>
                    <p className="table-recon-data order-break">
                      {item.dataItem.orderId}
                    </p>
                  </td>
                  <td>
                    <p className="table-recon-data">
                      {item.RESPONSE_STATUS === "INVALID"
                        ? "INVALID"
                        : item.requestAmount}
                    </p>
                  </td>
                  <td>
                    <p style={statusStyle(item.responseData?.RESPONSE_STATUS)}>
                      {item.responseData?.RESPONSE_STATUS}
                    </p>
                  </td>
                  <td>
                    <p className="table-recon-data status-table">
                      {formattedDate} {formattedTime}
                    </p>
                  </td>
                  <td>
                    <button
                      className="view-btn-1"
                      onClick={() => viewData(item)}
                    >
                      View
                    </button>
                  </td>
                  <td>
                    {reconArr.includes(item) ? (
                      <FiMinus
                        size={22}
                        onClick={() => handleRemoveTxn(item)}
                      />
                    ) : (
                      <MdAdd size={22} onClick={() => handleAddTxn(item)} />
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      <div className="add-recon-btn-container">
        <button className="submit-recon-btn" onClick={handleSubmitReconTxns}>
          Send Reconciliation
        </button>
      </div>
      {openModal && modalData && (
        <Modal modalData={modalData} setOpenModal={setOpenModal} />
      )}
    </div>
  );
};

export default TransactionTable;
